'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'beer-mug-empty';
var width = 576;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M432 48l0 416-352 0 0-416 352 0zm16 416l0-107.1 128-64 0-196.9-128 0 0-64-384 0 0 448 384 0 0-16zM560 283.1l-112 56 0-227.1 112 0 0 171.1zM176 128l-16 0 0 256 16 0 0-256zm160 0l0 256 16 0 0-256-16 0zm-72 0l-16 0 0 256 16 0 0-256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;